import React from 'react';
import { Skeleton } from 'antd';

export default function ListingCardSkeleton() {
  return (
    <div className="listing-card-skeleton-container">
      <Skeleton
        className="listing-card-skeleton"
        loading
        active
        title={false}
        avatar={{
          shape: 'square',
          size: '100%',
        }}
      />
    </div>
  );
}
